<div class="charge-group" [class.disabled]="disabled" [class.enabled]="!disabled">
  <div class="group-header">
    @if (!disabled) {
      <button
        (click)="expanded = !expanded"
        class="expand-btn"
        [title]="expanded ? 'Collapse Details' : 'Expand Details'"
        >
        <i class="material-symbols-rounded">{{ expanded ? 'expand_more' : 'chevron_right' }}</i>
      </button>
    }
    @if (disabled) {
      <div class="lock-icon">
        <i class="material-symbols-rounded">lock</i>
      </div>
    }
    <div class="group-content">
      <label class="group-label" [class.disabled]="disabled" [class.enabled]="!disabled" [class.has-data]="hasData">
        {{ label }} <span class="item-count" [class.has-items]="lineItemCount > 0">({{ lineItemCount }})</span>
      </label>
    </div>
    <div class="total-input">
      @if (disabled) {
        <div class="disabled-total">
          --
        </div>
      }
      @if (!disabled) {
        <app-smart-input
          type="number"
          [value]="group.total"
          (valueChange)="handleTotalChange($event)"
        ></app-smart-input>
      }
    </div>
  </div>

  @if (!disabled && (expanded || (group.lineItems && group.lineItems.length > 0))) {
    <div [class.hidden]="!expanded" class="line-items-section">
      <div>
        @for (item of group.lineItems; track $index; let i = $index) {
          <div class="line-item">
            <input
              class="description-input"
              placeholder="Description"
              [ngModel]="item.description"
              (ngModelChange)="updateLineItem(i, 'description', $event)"
              />
            <div class="amount-wrapper">
              <span class="currency-symbol">$</span>
              <input
                #amountInput
                type="text"
                [attr.data-index]="i"
                [value]="editingAmountIndex === i ? amountInput.value : (formattedAmounts[i] || '0.00')"
                (focus)="onAmountFocus(i)"
                (input)="onAmountInput(i, $event)"
                (blur)="onAmountBlur(i, $event)"
                />
            </div>
            <!-- Move Item Button & Dropdown -->
            <button
              cdkOverlayOrigin
              #moveTrigger="cdkOverlayOrigin"
              (click)="toggleMoveMenu(i)"
              class="action-btn move"
              title="Move Item to another group"
              >
              <i class="material-symbols-rounded">swap_horiz</i>
            </button>
            <!-- Rendered in the CDK overlay layer so the section's overflow: hidden and the
                 dialog's scroll viewport can't clip it; flips above the button when there is
                 no room below (DEV-15614). -->
            <ng-template
              cdkConnectedOverlay
              [cdkConnectedOverlayOrigin]="moveTrigger"
              [cdkConnectedOverlayOpen]="moveMenuOpen === i"
              [cdkConnectedOverlayPositions]="moveMenuPositions"
              [cdkConnectedOverlayHasBackdrop]="true"
              cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
              (backdropClick)="closeMoveMenu(i)"
              (detach)="closeMoveMenu(i)"
              >
              <div class="move-menu">
                <div class="move-menu-header">Move to...</div>
                <div class="move-menu-columns">
                  <div class="move-menu-column">
                    <div class="move-menu-column-title supply">Supply</div>
                    @for (target of supplyMoveTargets; track target.value) {
                      <button (click)="handleMoveItem(i, target.value)" class="move-menu-item">
                        {{ target.label }}
                      </button>
                    }
                  </div>
                  <div class="move-menu-column">
                    <div class="move-menu-column-title distribution">Distribution</div>
                    @for (target of distributionMoveTargets; track target.value) {
                      <button (click)="handleMoveItem(i, target.value)" class="move-menu-item">
                        {{ target.label }}
                      </button>
                    }
                  </div>
                </div>
              </div>
            </ng-template>
            <button
              (click)="removeLineItem(i)"
              class="action-btn delete"
              title="Delete Item"
              >
              <i class="material-symbols-rounded">delete</i>
            </button>
          </div>
        }
      </div>
      <button (click)="addLineItem()" class="add-item-btn">
        <i class="material-symbols-rounded">add</i> Add Item
      </button>
    </div>
  }
</div>
